import {InboxModel} from '../../../libs/shared/core/src/models/api/inboxModel';

/*
 * Types.
 */

export const enum SandboxInboxTypesEnum {
  /** In v2, the one and only sandbox inbox. In v3, the email inbox. */
  GENERAL = 'GENERAL',
  /** In v3, the analytics inbox. */
  ANALYTICS = 'ANALYTICS',
  /** In v3, the live chat inbox. */
  CHAT = 'CHAT',
}

const sandboxInboxAliases: {[type in SandboxInboxTypesEnum]: ReadonlyArray<string>} = {
  [SandboxInboxTypesEnum.GENERAL]: ['demo_inbox', 'sample_support', 'demo_email'],
  [SandboxInboxTypesEnum.ANALYTICS]: ['demo_analytics'],
  [SandboxInboxTypesEnum.CHAT]: ['demo_live_chat'],
};

export function isSandboxInbox(inbox: InboxModel, type: SandboxInboxTypesEnum) {
  return sandboxInboxAliases[type].includes(inbox.alias);
}

const sortedSandboxInboxTypes: ReadonlyArray<SandboxInboxTypesEnum> = [
  SandboxInboxTypesEnum.GENERAL,
  SandboxInboxTypesEnum.ANALYTICS,
  SandboxInboxTypesEnum.CHAT,
];

export function computeSandboxInboxSortKey(inbox: InboxModel): number {
  const sortIndex = sortedSandboxInboxTypes.findIndex((type) => isSandboxInbox(inbox, type));
  return sortIndex >= 0 ? sortIndex : Number.MAX_SAFE_INTEGER;
}
